import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Icon = ({ icon, style, className }) => (
  <span className={classNames(`qm-icon-${icon}`, className)} style={style} />
);

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
};

Icon.defaultProps = {
  style: {},
  className: '',
};

export default Icon;
